import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';
import { Question } from '../../../../classes';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'question-title',
  templateUrl: './question-title.component.html',
  styleUrls: ['./question-title.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTitleComponent implements OnInit {
  @Input() question: Question;
  @Input() questionFormGroup: FormGroup;
  subscriptions: Subscription[] = [];
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    this.subscriptions.push(
      this.question
        .getChildTracker('text')
        .onContentUpdate.subscribe(() => this.refreshView())
    );
    if (this.questionFormGroup)
      this.subscriptions.push(
        this.questionFormGroup.statusChanges.subscribe(() => this.refreshView())
      );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  private refreshView() {
    this.cdRef.detectChanges();
  }
}
